import { z } from "zod";
import { idSchema, localeSchema } from "./common.js";

export const tenantStatusSchema = z.enum(["trial", "active", "suspended", "closed"]);
export type TenantStatus = z.infer<typeof tenantStatusSchema>;

export const tenantSchema = z.object({
  id: idSchema,
  name: z.string().min(1).max(200),
  status: tenantStatusSchema,
  defaultLocale: localeSchema,
  createdAt: z.iso.datetime(),
});
export type Tenant = z.infer<typeof tenantSchema>;

export const userRoleSchema = z.enum(["owner", "admin", "billing", "user", "group_manager"]);
export type UserRole = z.infer<typeof userRoleSchema>;

export const userSchema = z.object({
  id: idSchema,
  tenantId: idSchema,
  email: z.email(),
  displayName: z.string().min(1).max(200),
  role: userRoleSchema,
  locale: localeSchema,
  createdAt: z.iso.datetime(),
});
export type User = z.infer<typeof userSchema>;

/** Closing a workspace asks for the owner's password and the workspace's name, typed out. */
export const workspaceCloseRequestSchema = z.object({
  confirmName: z.string().min(1).max(200),
  currentPassword: z.string().min(1).max(1024),
});
export type WorkspaceCloseRequest = z.infer<typeof workspaceCloseRequestSchema>;
export const workspaceClosedSchema = z.object({ deleteAfter: z.iso.datetime() });
export type WorkspaceClosed = z.infer<typeof workspaceClosedSchema>;

/** A new name for the workspace, as shown in the console and in invitations. */
export const workspaceRenameRequestSchema = z.object({ name: z.string().trim().min(1).max(200) });
export type WorkspaceRenameRequest = z.infer<typeof workspaceRenameRequestSchema>;
